import {Truncate} from '@dropbox/dig-components/truncate';
import {Text} from '@dropbox/dig-components/typography';
import {withShade} from '@dropbox/dig-foundations';
import {UIIcon} from '@dropbox/dig-icons';
import {PinLine} from '@dropbox/dig-icons/assets';
import {LabelGroup} from 'components/DSYS/LabelGroup';
import {useSkeletonFadeIn} from 'components/DSYS/SkeletonFadeIn';
import {NewsThumbnail} from 'components/news/NewsThumbnail';
import {ROUTE_PATHS} from 'constant';
import {DashboardState} from 'views/home/dashboard/dashboardModel';
import {Tile} from 'views/home/dashboard/Tile';
import {TileHeaderLink} from 'views/home/dashboard/TileListFooter';
import {TileListRow} from 'views/home/dashboard/TileListRow';
import {TileRowLink} from 'views/home/dashboard/TileRowLink';
import {TileListSkeleton} from 'views/home/dashboard/tiles/TileListSkeleton';
import {TileScroller} from 'views/home/dashboard/TileScroller';

export const NewsTile = ({state}: {state: DashboardState}) => {
  const bodyRef = useSkeletonFadeIn(state.newsLoading);
  if (state.newsLoading) {
    return <TileListSkeleton tileId="news" accessory="thumbnail" rows={8} />;
  }

  return (
    <Tile
      tileId="news"
      bodyRef={bodyRef}
      accessory={state.news.length > 0 ? <TileHeaderLink to={ROUTE_PATHS.NEWS} /> : undefined}
    >
      <TileScroller gap="4">
        {state.news.map((item) => {
          const shade = withShade({style: {marginInline: -8, cursor: 'pointer'}});
          const href =
            item.postId !== undefined
              ? ROUTE_PATHS.NEWS_POST.replace(':identifier', String(item.postId))
              : ROUTE_PATHS.NEWS;
          return (
            <TileRowLink key={item.id} to={href}>
              <TileListRow shade={shade}>
                <LabelGroup
                  align="top"
                  withLeftAccessory={
                    item.postId !== undefined ? (
                      <NewsThumbnail id={item.postId} isNewsFeed isSmall />
                    ) : undefined
                  }
                  withText={
                    <Text isBold tagName="div" style={{minWidth: 0}}>
                      <Truncate observeParent>{item.title}</Truncate>
                    </Text>
                  }
                  withSubtext={
                    <Text
                      size="small"
                      color="faint"
                      style={{display: 'flex', alignItems: 'center', gap: 4}}
                    >
                      {item.pinned && <UIIcon src={PinLine} size="small" color="Text Subtle" />}
                      {item.date}
                    </Text>
                  }
                />
              </TileListRow>
            </TileRowLink>
          );
        })}
      </TileScroller>
    </Tile>
  );
};
